import { Check } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const suitable = [
  "Frequently shave or wax their underarms",
  "Experience shaving-related irritation or bumps",
  "Want to reduce unwanted underarm hair",
  "Want a longer-term alternative to repeated hair removal",
];

export const WhoIsThisFor = () => (
  <section data-testid="who-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <SectionHead
        index="09"
        eyebrow="Who Is This For?"
        title="Is Underarm Laser Hair Reduction Right For You?"
        align="center"
      />
      <p className="mt-6 text-center text-base font-light text-ink/60">Suitable for people who:</p>
      <div className="mt-10 grid sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
        {suitable.map((item, i) => (
          <Reveal key={item} delay={i * 0.06}>
            <div
              data-testid={`who-point-${i + 1}`}
              className="flex items-start gap-4 rounded-3xl border border-champagne/60 bg-white/60 p-6 transition-[background-color,transform] duration-500 hover:-translate-y-1 hover:bg-white"
            >
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal/10">
                <Check className="w-3.5 h-3.5 text-teal" strokeWidth={2.5} />
              </span>
              <span className="text-base font-light leading-relaxed text-ink/75">{item}</span>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.3}>
        <p className="mt-10 mx-auto w-fit rounded-full border border-champagne px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.16em] text-teal/80 text-center">
          A consultation is recommended before starting treatment.
        </p>
      </Reveal>
    </div>
  </section>
);
